import { useMutation } from '@tanstack/react-query'

import { agreeToOlInfoSharingConsent } from '@src/api'
import { DefaultApiAgreeToOlInfoSharingConsentRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useAgreeToOlConsent = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiAgreeToOlInfoSharingConsentRequest) =>
      agreeToOlInfoSharingConsent(axiosInstance, params),
  })
}
